import { FCM_MEMBERSHIP_REMINDER_MODAL_EXPERIMENT } from 'src/app/shared/fcm/configs';
import { createExperimentFcmConfig } from 'src/app/shared/hooks/experiment';

export const FCM_EXPERIMENT_MEMBERSHIP_REMINDER_MODAL = createExperimentFcmConfig({
	experimentName: ({ fcm: { config } }) => config?.experiment_name,
	fcmConfigs: {
		config: FCM_MEMBERSHIP_REMINDER_MODAL_EXPERIMENT,
	},
	isEnabled: ({ fcm: { config } }) => {
		return !!config?.experiment_name;
	},
});
